import type { ColaboratorResponse } from '@/app/models/avaliablePercent';
import formatterPercentualValue from '@/app/utils/percentualUtils';
import DataTable, { bodyCellSx, Column } from '@/components/common/DataTable';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton, TableCell, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface ProjectTableProps {
  projects: ColaboratorResponse[];
  onRemove?: (projectId: number) => void;
}

export default function ProjectTable({ projects, onRemove }: ProjectTableProps) {
  const { t } = useTranslation(['avaliablePercentage', 'common']);
  const theme = useTheme();

  const handleDelete = (projectId: number) => {
    if (onRemove) {
      onRemove(projectId);
    }
  };

  const columns: Column[] = [
    {
      key: 'collaborator',
      label: t('common:collaborator'),
    },
    {
      key: 'percentage',
      label: t('percentage'),
    },
    {
      key: 'actions',
      label: t('common:actions'),
      align: 'right',
    },
  ];

  const renderRow = (project: ColaboratorResponse) => (
    <>
      <TableCell sx={bodyCellSx}>{`${project.badge} - ${project.name}`}</TableCell>
      <TableCell sx={bodyCellSx}>{formatterPercentualValue(project.percent)}</TableCell>
      <TableCell align="right" sx={bodyCellSx}>
        {onRemove && (
          <IconButton size="small" onClick={() => handleDelete(project.id)}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        )}
      </TableCell>
    </>
  );

  return (
    <DataTable
      columns={columns}
      data={projects}
      renderRow={renderRow}
      emptyMessage={t('no.collaborators.assigned')}
      getRowKey={(item) => item.badge}
      size="small"
      maxHeight={theme.spacing(50)}
      stickyHeader={false}
    />
  );
}
